import { ActionsCreators, connectToJava } from "@tipico/java-react-connector";
import LimitsAndClosure, {
    LimitsAndClosureProps
} from "../../components/LimitsAndClosure/LimitsAndClosure";

export const LIMITS_AND_CLOSURE_STATE = "limitsAndClosureDetails";
export const LIMITS_AND_CLOSURE_ACTION = "limitsAndClosureUpdateRequest";

export type Actions = {
    onUpdateLimitsAndClosure: (
        newLimitsAndClosure: LimitsAndClosureStreamProps
    ) => void;
};

const actionsCreators: ActionsCreators<Actions> = {
    onUpdateLimitsAndClosure: {
        creator: (newLimitsAndClosure: LimitsAndClosureStreamProps) => {
            return newLimitsAndClosure;
        },
        name: LIMITS_AND_CLOSURE_ACTION
    }
};

const initialData = {
    country: "",
    data: {
        amount: "",
        displayableValidityKeys: [],
        reason: -1,
        selectedValidityKey: "",
        validity: -1
    },
    futureLimit: {
        activateDate: 0,
        period: -1,
        value: 100
    },
    showNewShortTermExclusions: false,
    type: "",
    updated: false,
    validityDate: 0
};

export type LimitsAndClosureDataType = {
    country: string;
    data: {
        amount: any;
        displayableValidityKeys: string[];
        reason: number;
        selectedValidityKey: string;
        validity: number;
    };
    futureLimit: {
        activateDate: number;
        period: number;
        value: number;
    };
    type: any;
    showNewShortTermExclusions: boolean;
    updated: boolean;
    validityDate: number;
};

export interface LimitsAndClosureStreamProps {
    EXCLUSION: LimitsAndClosureDataType;
    LOSS: LimitsAndClosureDataType;
    PAYIN: LimitsAndClosureDataType;
    PAYIN_RGM: LimitsAndClosureDataType;
    CLOSURE: LimitsAndClosureDataType;
}

export const INITIAL_STATE: LimitsAndClosureStreamProps = {
    CLOSURE: initialData,
    EXCLUSION: initialData,
    LOSS: initialData,
    PAYIN: initialData,
    PAYIN_RGM: initialData
};

export default connectToJava<
    LimitsAndClosureProps,
    LimitsAndClosureStreamProps,
    {
        [LIMITS_AND_CLOSURE_STATE]: LimitsAndClosureStreamProps;
    },
    Actions
>({
    actionsCreators,
    state: {
        [LIMITS_AND_CLOSURE_STATE]: INITIAL_STATE
    },
    stateMapper: ({ limitsAndClosureDetails: state }) => state
})(LimitsAndClosure);
